import { createScorableTab } from './scorableTabFactory';
import { registerTab } from './tabRegistry';

// Default flow — "Failed" tab. The API's flow-statuses response returns
// status values in this exact Title Case ("Failed", not "failed") — see
// GET /assignments/:id/flow-statuses — and that's what becomes
// AssignmentPipeline's `currentFilter`, so the registry key here has to
// match it exactly for getTabComponent to resolve.
const FailedTab = createScorableTab('Failed', 'No candidates have failed yet.');

registerTab({
  stateMachineKey: 'default',
  state: 'Failed',
  component: FailedTab,
});

export default FailedTab;
